import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ClassicalCiphersModule = () => (
  <QPhototModuleSubtopic
    title="Caesar, Playfair, Vigenere, Hill Ciphers"
    videos={[
      "https://www.youtube.com/embed/p0HM_mnA_HM",
      "https://www.youtube.com/embed/HV4sG6ZpWm8",
      "https://www.youtube.com/embed/TIcw0mYoIjc",
      "https://www.youtube.com/embed/Ic4BzVggNY8",
      "https://www.youtube.com/embed/6T46sgty4Mk",
      "https://www.youtube.com/embed/qU1kcpuJXaw"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "1)The following is the cipher text of a Hill cipher QVNAYQHI using the key matrix\n\nWhat is the plaintext the resulted in ciphertext?",
          image:"/cns_3.png"
      },
      {
        text:
          "2) Differentiate between a stream and a block cipher. How can one make these\ndifferences disappear?"
      },
      {
        text:
          "3)perform encryption and decryption on the given plaintext using the Hill cipher technique with provided Key Matrix.\nPlaintext: CSE",
          image:"/cns_4.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default ClassicalCiphersModule;
